import React from 'react';

interface CtaButtonProps {
  onClick: () => void;
  label: string;
}

/**
 * Call-to-action button for scrolling to expertise form
 */
export const CtaButton: React.FC<CtaButtonProps> = ({ onClick, label }) => (
  <div className="flex justify-center py-4">
    <button
      type="button"
      onClick={onClick}
      className="btn btn-primary h-auto min-h-0 max-w-full whitespace-normal text-wrap px-6 py-4 text-center font-neutrifb text-base leading-snug text-white shadow-md transition-all hover:shadow-lg sm:px-10 sm:text-lg"
    >
      {label}
    </button>
  </div>
);
